export function SplashScreen() {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--fg3)" }}>
      <span className="td-small">Carregando…</span>
    </div>
  );
}
